import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';

const DragHandle: React.FC = () => (
  <span className='gx-draggable-icon gx-pt-2'>
    <i className='icon icon-expand' style={{ fontSize: 25 }} />
  </span>
);

export default React.memo(SortableHandle(DragHandle));
